import { Component, Inject, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MappingComponent } from '../../mapping/mapping.component';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';


@Component({
    selector: 'app-delete-farm',
    templateUrl: './delete-farm.component.html',
    styleUrls: ['./delete-farm.component.css'],
    standalone: false
})
export class DeleteFarmComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  public dialogRef: MatDialogRef<MappingComponent>,
  public dialog: MatDialog,
  public translate: TranslateService) { }

  ngOnInit(): void {
  }

  deleteFarm() {
    this.dialogRef.close({"option": "delete"});
  }

  cancel(): void {
    this.dialogRef.close();
  }

}
